module.exports = __webpack_public_path__ + "static/media/18ECA22.882fc669.jpg";